import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { UserAuthService } from "src/app/services/userauth.service";
import { AdminAuthService } from "src/app/services/adminauth.service";
import { ExamService } from "src/app/services/exam.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { User } from "src/app/models/user";
import { SERVERRESPONSERESULT } from "src/app/models/serverresponse";

@Component({
  selector: "hkt-pageview",
  templateUrl: "./pageview.component.html",
  styleUrls: ["./pageview.component.scss"],
})
export class PageViewComponent implements OnInit, OnDestroy {
  user: User;
  websiteName: string;
  routerParams: Subscription;
  userExamId: number;

  constructor(
    private router: Router,
    private userAuthService: UserAuthService,
    private adminAuthService: AdminAuthService,
    private examService: ExamService,
    private activatedRoute: ActivatedRoute,
    private modalDialogService: ModalDialogService,
  ) {}

  ngOnInit() {
    this.user = new User();
    this.websiteName = "";

    this.routerParams = this.activatedRoute.params.subscribe(params => {
      this.userExamId = +params["id"];
      this.examService.loadExamResults(this.userExamId).subscribe(
        response => {
          if (response == false) {
            this.modalDialogService.showAlert(Config.APP_NAME, "Error loading the exam");
            return;
          }
          this.websiteName = this.examService.currentExam.name;
          this.user = this.examService.currentUser;
        },
        error => {
          console.error("Error: " + error);
        },
      );
    });
  }

  ngOnDestroy() {
    this.routerParams.unsubscribe();
  }

  onLogout(): boolean {
    if (this.userAuthService.currentUser.id != -1) {
      this.userAuthService.logout();
      this.router.navigate(["viewlogin", this.userExamId]);
      return false;
    }
    if (this.adminAuthService.currentUser.id != -1) {
      this.adminAuthService.logout().subscribe(response => {
        if (response.result == SERVERRESPONSERESULT.OK) {
          this.router.navigate(["viewlogin", this.userExamId]);
        }
      });
    }
    return false;
  }

  toggleMenu(): void {}
}
